const BASE_URL = 'http://43.205.42.216:8001'

//Common
export const UPLOAD_IMAGE = `${BASE_URL}/common/upload-file/`

//Admin ::  Country Settings
// export const VISIT_TYPE = `${BASE_URL}/admin/visit-type/`
export const BANNER = `${BASE_URL}/admin/banner/`

export const STATE = `${BASE_URL}/admin/state/`
export const DISTRICT_LIST = `${BASE_URL}/admin/city/`
export const TALUK = `${BASE_URL}/admin/taluk/`

// //Admin :: Provider Management
export const USER_LIST = `${BASE_URL}/users/`
// export const ADD_USER = `${BASE_URL}/users/sign-up/`
// export const DOCTOR_LIST = `${BASE_URL}/doctors/`
// export const SLOT_TYPE_LIST = `${BASE_URL}/admin/slot_type/`
// export const DOCTORS_SLOT = `${BASE_URL}/doctors/doctor_slots/`
// export const HOSPITAL_LIST = `${BASE_URL}/hospital/`

export const GET_IMA_BRANCH = `${BASE_URL}/admin/ima-branch/`
export const PHARMACY_LIST = `${BASE_URL}/pharmacy/`
export const SCAN_CENTER_LIST = `${BASE_URL}/scan-center/`
export const LABORATORY_LIST = `${BASE_URL}/laboratory/`
export const SCAN_CATEGORY_LIST = `${BASE_URL}/admin/scan_category/`
export const AMBULANCE_LIST = `${BASE_URL}/ambulance/`
export const BOOKING_LIST = `${BASE_URL}/booking/`
export const AMBULANCE_TYPE_LIST = `${BASE_URL}/ambulance/types/`
export const AMBULANCE_FACILITIES_LIST = `${BASE_URL}/ambulance/facilities/`
export const APPOINTMENT_DURATION_LIST = `${BASE_URL}/booking/list-appointment-duration/`
export const APPOINTMENT_STATUS_LIST = `${BASE_URL}/doctors/list-appointment-status/`

// export const LIST_SUGGESTIONS_CATEGORY = `${BASE_URL}/pharmacy/list-suggestions-category/`

// Active Pharmacy
export const APPROVED_PHARMACY_BY_ADMIN = `${BASE_URL}/pharmacy/activate/`

// add Bulk Pharmacy By Admin

//Admin :: CMS
export const CMS_VIEW = `${BASE_URL}/cms-view/`

//Auth
export const LOGIN = `${BASE_URL}/admin/login/`

//  User
export const USER_URL = `${BASE_URL}/user/`

// Store Type
export const STORE_TYPE_URL = `${BASE_URL}/admin/store_type/`
export const STORE_TYPE_ACTIVE_INACTIVE = `${BASE_URL}/admin/store_type/activate-deactivate-store-type/` // Active Inactive Store Type URL

// store
export const STORE = `${BASE_URL}/stores/`
export const ACTIVATE_STORE = `${BASE_URL}/stores/activate/`
export const DEACTIVATE_STORE = `${BASE_URL}/stores/deactivate/`
export const ADD_BULK_STORE_BY_EXCEL = `${BASE_URL}/stores/add-bulk-stores-excel-upload/`

//Store Enquiry
export const ENQUIRY_LIST = `${BASE_URL}/interested-service/`

// store Roles

export const LIST_STORE_ROLES = `${BASE_URL}/api/roles/list-roles/`
export const ADD_STORE_ROLES = `${BASE_URL}/api/roles/add-role/`
export const UPDATE_STORE_ROLES = `${BASE_URL}/api/roles/update-role/`
export const STORE_ROLES_ACTIVE_INACTIVE = `${BASE_URL}/api/roles/activate-deactivate-role/` // Active Inactive Store Role URL

// product category

export const LIST_PRODUCT_CATEGORY = `${BASE_URL}/stores/list-product-category/`
export const ADD_PRODUCT_CATEGORY = `${BASE_URL}/stores/add-product-category/`
export const UPDATE_PRODUCT_CATEGORY = `${BASE_URL}/stores/update-product-category/`
export const DELETE_PRODUCT_CATEGORY = `${BASE_URL}/stores/delete-product-category/`
// Product Sub Category
export const LIST_SUB_PRODUCT_CATEGORY = `${BASE_URL}/stores/list-product-sub-category/`
export const ADD_SUB_PRODUCT_CATEGORY = `${BASE_URL}/stores/add-product-sub-category/`
export const UPDATE_SUB_PRODUCT_CATEGORY = `${BASE_URL}/stores/update-product-sub-category/`
export const DELETE_SUB_PRODUCT_CATEGORY = `${BASE_URL}/stores/delete-product-sub-category/`

// Product
export const ADD_PRODUCT = `${BASE_URL}/stores/add-product/`
export const PRODUCT_LIST = `${BASE_URL}/stores/list-products/`

export const PRODUCT_DETAILS = `${BASE_URL}/stores/list-product/products_id/`
export const UPDATE_PRODUCT = `${BASE_URL}/stores/update-product/`
export const DELETE_PRODUCT = `${BASE_URL}/stores/delete-product/`
export const PRODUCT_STATUS_CHANGE = `${BASE_URL}/stores/activate-deactivate-product/`
export const BULK_UPLOAD_PRODUCT_BY_EXCEL = `${BASE_URL}/stores/add-product-excel-upload/`

// order
export const ORDER_URL = `${BASE_URL}/orders/`

// Product Sub Child Category
export const PRODUCT_CHILD_SUB_CATEGORY_LIST = `${BASE_URL}/stores/list-product-child-sub-category/`
export const ADD_PRODUCT_CHILD_SUB_CATEGORY_LIST = `${BASE_URL}/stores/add-product-child-sub-category/`
export const UPDATE_PRODUCT_CHILD_SUB_CATEGORY_LIST = `${BASE_URL}/stores/update-product-child-sub-category/`
export const DELETE_PRODUCT_CHILD_SUB_CATEGORY_LIST = `${BASE_URL}/stores/delete-product-child-sub-category/`

// Brand Management
export const BRAND_URL = `${BASE_URL}/admin/brand/`

// Admin product New Api Interrogation

export const ADMIN_ADD_PRODUCT = `${BASE_URL}/admin/products/add-product/`
export const ADMIN_PRODUCT_LIST = `${BASE_URL}/admin/products/list-products/`
export const ADMIN_LIST_PRODUCT_DETAILS = `${BASE_URL}/admin/products/list-product/products_id/`

export const ADMIN_UPDATE_PRODUCT = `${BASE_URL}/admin/products/update-product/`
export const ADMIN_DELETE_PRODUCT = `${BASE_URL}/admin/products/delete-product/`
export const ADMIN_PRODUCT_STATUS_CHANGE = `${BASE_URL}/admin/products/activate-deactivate-product/`

// Store group

export const ADMIN_STORE_GROUP_LIST = `${BASE_URL}/admin/store_group/list-store-groups/`
export const ADMIN_STORE_GROUP_DETAILS = `${BASE_URL}/admin/store_group/get-store-group-details/`
export const ADD_STORE_GROUP = `${BASE_URL}/admin/store_group/add-new-store-group/`
export const UPDATE_STORE_GROUP = `${BASE_URL}/admin/store_group/update-store-group/`
export const ACTIVE_INACTIVE_STORE_GROUP = `${BASE_URL}/admin/store_group/activate-deactivate-group/`
export const STORE_GROUP_DELETE = `${BASE_URL}/admin/store_group/delete-store-group/`

// Market palace

// Super Category

export const MARKETPLACE_SUPER_CATEGORY = `${BASE_URL}/admin/market-place-super-category/`

// Category

export const MARKETPLACE_CATEGORY_LIST = `${BASE_URL}/admin/market-place/list-categories/`
export const MARKETPLACE_CATEGORY_DETAILS = `${BASE_URL}/admin/market-place/list-categories/`
export const ADD_MARKETPLACE_CATEGORY = `${BASE_URL}/admin/market-place/add-category/`
export const UPDATE_MARKETPLACE_CATEGORY = `${BASE_URL}/admin/market-place/update-category/`
export const DELETE_MARKETPLACE_CATEGORY = `${BASE_URL}/admin/market-place/delete-category/`

// Sub Category

export const MARKETPLACE_SUBCATEGORY_LIST = `${BASE_URL}/admin/market-place/list-sub-categories/`
export const MARKETPLACE_SUBCATEGORY_DETAILS = `${BASE_URL}/admin/market-place/list-sub-categories/`
export const ADD_MARKETPLACE_SUBCATEGORY = `${BASE_URL}/admin/market-place/add-sub-category/`
export const UPDATE_MARKETPLACE_SUBCATEGORY = `${BASE_URL}/admin/market-place/update-sub-category/`
export const DELETE_MARKETPLACE_SUB_CATEGORY = `${BASE_URL}/admin/market-place/delete-sub-category/`

// Brand

export const MARKETPLACE_BRAND_LIST = `${BASE_URL}/admin/market-place/list-brands/`
export const MARKETPLACE_BRAND_DETAILS = `${BASE_URL}/admin/market-place/list-brands/`
export const ADD_MARKETPLACE_BRAND = `${BASE_URL}/admin/market-place/add-brand/`
export const UPDATE_MARKETPLACE_BRAND = `${BASE_URL}/admin/market-place/update-brand/`
export const DELETE_MARKETPLACE_BRAND = `${BASE_URL}/admin/market-place/delete-brand/`

// Market product List

export const MARKETPLACE_PRODUCT_LIST = `${BASE_URL}/market-place/list-products/`
export const MARKETPLACE_PRODUCT_DETAILS = `${BASE_URL}/market-place/list-product/products_id/`

// Grocery Services

export const SERVICE_LIST = `${BASE_URL}/grocery-service/list-grocery-services/`
export const ADD_SERVICE = `${BASE_URL}/grocery-service/add-grocery-service/`
export const UPDATE_SERVICE = `${BASE_URL}/grocery-service/update-grocery-service/`
export const DELETE_SERVICE = `${BASE_URL}/grocery-service/delete-grocery-service/`
export const STORE_SERVICE_ACTIVE_INACTIVE = `${BASE_URL}/grocery-service/activate-deactivate-grocery-service/` // Active Inactive Store Services URL

// Store Tag
export const STORE_TAG_LIST = `${BASE_URL}/stores/tags/list-store-tags/`
export const ADD_STORE_TAG = `${BASE_URL}/stores/tags/add-store-tag/`
export const UPDATE_STORE_TAG = `${BASE_URL}/stores/tags/update-store-tag/`
export const DELETE_STORE_TAG = `${BASE_URL}/stores/tags/delete-store-tag/`
export const STORE_TAG_ACTIVE_INACTIVE = `${BASE_URL}/stores/tags/activate-deactivate-tag/` // Active Inactive Store Tag URL

// Job Category
export const JOB_CATEGORY_LIST = `${BASE_URL}/admin/jobs/category-list/`
export const ADD_JOB_CATEGORY = `${BASE_URL}/admin/jobs/add-category-list/`
export const UPDATE_JOB_CATEGORY = `${BASE_URL}/admin/jobs/update-category-list/`
export const DELETE_JOB_CATEGORY = `${BASE_URL}/admin/jobs/delete-category-list/`

// Job SUB Category
export const JOB_SUB_CATEGORY_LIST = `${BASE_URL}/admin/jobs/sub-category-list/`
export const ADD_JOB_SUB_CATEGORY = `${BASE_URL}/admin/jobs/add-sub-category-list/`
export const UPDATE_JOB_SUB_CATEGORY = `${BASE_URL}/admin/jobs/update-sub-category-list/`
export const DELETE_JOB_SUB_CATEGORY = `${BASE_URL}/admin/jobs/delete-sub-category-list/`

// Health Care Management

// ------------------- Doctor List -------------------
export const DOCTOR_LIST = `${BASE_URL}/stores/doctor/list-members/`
export const DOCTOR_ACTIVE_INACTIVE = `${BASE_URL}/stores/doctor/activate-deactivate-member/`
export const DOCTOR_DETAILS_API = `${BASE_URL}/stores/doctor/get-member/`

// ------------------- Doctor Specification -------------------
export const DOCTOR_SPECIFICATION_LIST = `${BASE_URL}/admin/doctor-speciality/list-specialities/`
export const ADD_DOCTOR_SPECIFICATION = `${BASE_URL}/admin/doctor-speciality/`
export const UPDATE_DOCTOR_SPECIFICATION = `${BASE_URL}/admin/doctor-speciality/update-speciality/`
export const DOCTOR_SPECIFICATION_ACTIVE_INACTIVE = `${BASE_URL}/admin/doctor-speciality/activate-deactivate-speciality/`

// Job Tag Endpoints
export const JOB_TAG_LIST = `${BASE_URL}/admin/jobs/job-tag-list/`
export const JOB_TAG_BY_ID = `${BASE_URL}/admin/jobs/job-tag/`
export const CREATE_JOB_TAG = `${BASE_URL}/admin/jobs/add-job-tag/`
export const UPDATE_JOB_TAG = `${BASE_URL}/admin/jobs/update-job-tag/`
export const DELETE_JOB_TAG = `${BASE_URL}/admin/jobs/delete-job-tag/`
export const JOB_TAG_ACTIVE_INACTIVE = `${BASE_URL}/admin/jobs/activate-deactivate-job-tag/`

// ================= Store Video Categories =================
export const STORE_VIDEO_CATEGORY_LIST = `${BASE_URL}/stores/videos/video-category/`

export const ADD_STORE_VIDEO_CATEGORY = `${BASE_URL}/stores/videos/video-category/add-video-category/`

export const UPDATE_STORE_VIDEO_CATEGORY = `${BASE_URL}/stores/videos/video-category/update/`

export const STORE_VIDEO_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/stores/videos/video-category/activate-deactivate/`

// ================= Store Videos =================

// Add store video
export const ADD_STORE_VIDEO = `${BASE_URL}/stores/videos/add-store-video/`

// List all store videos
export const STORE_VIDEO_LIST = `${BASE_URL}/stores/videos/`
// View all store videos
export const STORE_VIDEO_LIST_DETAILED = `${BASE_URL}/stores/videos/reactions/`

// Update store video
export const UPDATE_STORE_VIDEO = `${BASE_URL}/stores/videos/update/`

// Active / Inactive store video
export const STORE_VIDEO_ACTIVE_INACTIVE = `${BASE_URL}/stores/videos/activate-deactivate/`

// ================= Store Offer Category =================

// List all offer categories
export const OFFER_CATEGORY_LIST = `${BASE_URL}/store/offer/admin-offer-category/`

// Add new offer category
export const ADD_OFFER_CATEGORY = `${BASE_URL}/store/offer/admin-offer-category/add-Offer-category`

// Get offer category by ID
export const OFFER_CATEGORY_DETAILS = `${BASE_URL}/store/offer/admin-offer-category/`
// usage: `${OFFER_CATEGORY_DETAILS}${category_id}`

// Update offer category
export const UPDATE_OFFER_CATEGORY = `${BASE_URL}/store/offer/admin-offer-category/update/`
// usage: `${UPDATE_OFFER_CATEGORY}${category_id}`

// Activate / Deactivate offer category
export const OFFER_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/store/offer/admin-offer-category/activate-deactivate/`

// usage: `${OFFER_CATEGORY_ACTIVE_INACTIVE}${category_id}`

export const STORE_OFFER_LIST = `${BASE_URL}/store/offer/store_offer/`

export const STORE_OFFER_DETAILS = `${BASE_URL}/store/offer/store_offer/`
// ✅ UPDATE OFFER
export const UPDATE_STORE_OFFER = `${BASE_URL}/store/offer/store_offer/update/`

export const EVENT_CATEGORY = `${BASE_URL}/admin/event_categories/`

export const ADD_EVENT_CATEGORY = `${BASE_URL}/admin/event_categories/add-event-category/`

export const UPDATE_EVENT_CATEGORY = `${BASE_URL}/admin/event_categories/update/`

export const EVENT_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/admin/event_categories/activate-deactivate/`
// ================= Event Management =================
export const EVENT_LIST = `${BASE_URL}/customer/event/get-event/`

export const EVENT_LIST_DETAILS = `${BASE_URL}/customer/event/`

export const UPDATE_EVENT = `${BASE_URL}/customer/event/`
export const ACTIVE_INACTIVE_EVENT = `${BASE_URL}/customer/event/`

// Event Register User List
export const EVENT_REGISTER_USER_LIST = `${BASE_URL}/customer/event_register/event-user`

// ================= Event Sub Category =================

export const EVENT_SUB_CATEGORY_LIST = `${BASE_URL}/admin/event_subCategories/`

export const ADD_EVENT_SUB_CATEGORY = `${BASE_URL}/admin/event_subCategories/add-event-subcategory`

export const EVENT_SUB_CATEGORY_DETAILS = `${BASE_URL}/admin/event_subCategories/`

export const UPDATE_EVENT_SUB_CATEGORY = `${BASE_URL}/admin/event_subCategories/update/`

export const EVENT_SUB_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/admin/event_subCategories/activate-deactivate/`

// ================= Offer Sub Category =================

export const OFFER_SUBCATEGORY_LIST = `${BASE_URL}/store/offer/admin-offer-subcategory/`

export const ADD_OFFER_SUBCATEGORY = `${BASE_URL}/store/offer/admin-offer-subcategory/add-offer-subcategory`

export const OFFER_SUBCATEGORY_DETAILS = `${BASE_URL}/store/offer/admin-offer-subcategory/`
// usage: `${OFFER_SUBCATEGORY_DETAILS}${id}`

export const UPDATE_OFFER_SUBCATEGORY = `${BASE_URL}/store/offer/admin-offer-subcategory/update/`
// usage: `${UPDATE_OFFER_SUBCATEGORY}${id}`

export const OFFER_SUBCATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/store/offer/admin-offer-subcategory/activate-deactivate/`

// usage: `${OFFER_SUBCATEGORY_ACTIVE_INACTIVE}${id}`

// ================= JOB LIST APIs =================

// Provider Jobs
export const JOB_USER_LIST = `${BASE_URL}/admin/jobs/job-provider/list-jobs/`
export const JOB_USER_LIST_DETAILS = `${BASE_URL}/admin/jobs/job-provider/list-jobs/`

// Job Seeker Applied Jobs
export const JOB_SEEKER_APPLIED_LIST = `${BASE_URL}/admin/jobs/job-seeker/list-applied_jobs/`

// Store Jobs
export const STORE_JOB_LIST = `${BASE_URL}/stores/jobs/`
// export const STORE_JOB_LIST_DETAILS= `${BASE_URL}/stores/jobs/`

// Store Job Applications
export const STORE_JOB_APPLICATION_LIST = `${BASE_URL}/stores/jobs/job-seeker/applications`

// Job Category Active / Inactive
export const JOB_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/admin/jobs/update-category-status/`

// Job Sub Category Active / Inactive
export const JOB_SUB_CATEGORY_ACTIVE_INACTIVE = `${BASE_URL}/admin/jobs/update-subcategory-status/`
// Job Seeker Resume
export const JOB_SEEKER_RESUME_LIST = `${BASE_URL}/admin/jobs/job-seeker/list-candidate/`
export const JOB_SEEKER_RESUME_DETAILS = `${BASE_URL}/admin/jobs/job-seeker/list-candidate/`

// ================= Internship Program Super Category =================

export const INTERNSHIP_PROGRAM_SUPER_CATEGORY = `${BASE_URL}/Internship-Program-Super-Category/`

// ================= Internship Program Category =================

export const INTERNSHIP_PROGRAM_CATEGORY = `${BASE_URL}/internship-program-categories/`

// ================= Internship Program Sub Category =================

export const INTERNSHIP_PROGRAM_SUBCATEGORY = `${BASE_URL}/internship-program-subcategories/`

// ================= Internship Program =================

export const INTERNSHIP_PROGRAM = `${BASE_URL}/internships-program/`

// ================= Internship Program Apply =================

export const INTERNSHIP_PROGRAM_APPLIED_LIST = `${BASE_URL}/internship-applications/list-applied/`

// ================= Skill Program =================

// Program Types
export const SKILL_PROGRAM_TYPES = `${BASE_URL}/admin/skill-program-types/`
// Super Category
export const SKILL_PROGRAM_SUPER_CATEGORY = `${BASE_URL}/admin/Skill-Program-Super-Category/`

// Category
export const SKILL_PROGRAM_CATEGORY = `${BASE_URL}/admin/skill-program-category/`

// Sub Category
export const SKILL_PROGRAM_SUB_CATEGORY = `${BASE_URL}/admin/skill-program-sub-category/`

// ================= Skill Program =================
export const SKILL_PROGRAM_LIST = `${BASE_URL}/admin/skill-program/`
export const SKILL_PROGRAM_DETAILS = `${BASE_URL}/admin/skill-program/`
// ================= Skill Program Applied =================
export const SKILL_PROGRAM_APPLIED_LIST = `${BASE_URL}/skill-applications/list-applied/`
export const SKILL_PROGRAM_APPLIED_DETAILS = `${BASE_URL}/skill-applications/list-applied/`

// ================= Gig Category =================
export const GIG_SUPER_CATEGORY = `${BASE_URL}/admin/gigs-works-super-category/`
export const GIG_CATEGORY = `${BASE_URL}/admin/Gigs-Works-category/`
export const GIG_SUB_CATEGORY = `${BASE_URL}/admin/Gigs-Works-SubCategory/`

// ================= Gig Profile =================
export const GIG_PROFILE_LIST = `${BASE_URL}/gigs-works-profile/`
export const GIG_PROFILE_DETAILS = `${BASE_URL}/gigs-works-profile/details/`

export const GIG_HIRE_LIST = `${BASE_URL}/gigs-works-hire/`

// Vehicle Management Category and Sub Category
export const VEHICLE_TYPE = `${BASE_URL}/admin/vehicle-type/`
export const VEHICLE_FACILITY = `${BASE_URL}/admin/vehicle-facility/`
export const VEHICLE_CATEGORY = `${BASE_URL}/vehicle-category/`
export const VEHICLE_SUBCATEGORY = `${BASE_URL}/vehicles-subcategories/`
export const VEHICLE_DRIVER_LIST = `${BASE_URL}/drivers/`
export const VEHICLE_LIST = `${BASE_URL}/vehicles/`
export const VEHICLE_DETAILS = `${BASE_URL}/vehicles/`

// ================= Vehicle SOS Alerts =================
export const VEHICLE_SOS = `${BASE_URL}/vehicle-sos/`
// usage: list -> `${VEHICLE_SOS}`, details -> `${VEHICLE_SOS}${sos_id}`, resolve -> `${VEHICLE_SOS}${sos_id}/resolve/`

// ================= Feedback Type Management =================
export const FEEDBACK_TYPE = `${BASE_URL}/feedback-types/`
// usage: list -> `${FEEDBACK_TYPE}`, create -> `${FEEDBACK_TYPE}`, details/update/delete -> `${FEEDBACK_TYPE}${feedback_type_id}`, status -> `${FEEDBACK_TYPE}${feedback_type_id}/status`
export const FEEDBACK_TYPE_ACTIVE_INACTIVE = `${BASE_URL}/feedback-types/` // toggle status: `${FEEDBACK_TYPE_ACTIVE_INACTIVE}${feedback_type_id}/status`

// ================= User Feedback =================
export const USER_FEEDBACK = `${BASE_URL}/user/feedback/`
// usage: list -> `${USER_FEEDBACK}`, details -> `${USER_FEEDBACK}${feedback_id}`, status -> `${USER_FEEDBACK}${feedback_id}/status`
